<main class="u-content">
	<h1 class="u-heading--xl">Stap {{ step + 1 }}: {{ steps[step] }}</h1>

	<hr class="hr-full" />

	<ng-content></ng-content>

	<hr class="hr-full" />

	@if (isLastStep() && period() && !period()?.allowSubmit()) {
		<div class="c-message-box">
			<span class="icon-warning u-text--xlg"></span>
			<p>Je kan je subsidieaanvraag nog niet indienen. Je kan je subsidieaanvraag wel bijhouden door onderaan de pagina op de knop ‘opslaan’ te klikken. Wanneer de subsidieoproep definitief goedgekeurd is, zal je de aanvraag officieel kunnen indienen. We zullen je hiervan via mail (en op de websites van Toerisme Vlaanderen en Westtoer) op de hoogte brengen.</p>
		</div>

		<hr class="hr-full" />
	}

	<div *ngIf="!isDossier; else dossier" class="buttons">
		<button (click)="doAction(StepContainerAction.PREV)" [class.hide-button]="denyPrevious" class="c-btn c-btn--secundary">
			Vorige
		</button>
		<button (click)="doAction(StepContainerAction.SAVE)" [class.hide-button]="step === 0 && subsidyType !== 'hefboomproject'" class="c-btn-link">
			Aanvraag opslaan
		</button>
		@if (isLastStep()) {
			@if (!period() || period()?.allowSubmit()) {
				<button (click)="doAction(StepContainerAction.NEXT)" class="c-btn">
					Indienen
				</button>
			} @else {
				<button class="c-btn" disabled>
					Indienen
				</button>
			}
		} @else {
			<button (click)="doAction(StepContainerAction.NEXT)" class="c-btn">
				Volgende
			</button>
		}
	</div>

	<ng-template #dossier>
		<div class="buttons">
			<button class="c-btn c-btn--secundary hide-button"></button>
			<button class="c-btn-link hide-button"></button>
			<button (click)="doAction(StepContainerAction.DOSSIER_NEXT)" class="c-btn">Volgende</button>
		</div>
	</ng-template>
</main>
